














































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import MaterialGroupApi from "@/services/MaterialGroups";
import MaterialApi from "@/services/Materials";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import { MaterialGroup, UpdateMaterialSort, Material } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MMaterialListDetail extends CheckAdminLogin {
  // tableのheader設定配列
  private headers = [
    {
      text: "content name",
      align: "start",
      sortable: false,
      value: "title",
    },
    { text: "", align: "center", value: "actions", sortable: false },
  ];

  // 削除対象materialのuuid
  private targetItemUuid = "";

  // materialGroupのuuid
  private materialGroupUuid = this.$route.params.content;

  // tableのmaterialのデータ
  private listItems: Material[] = [];

  // materialGroup情報
  private materialGroup: MaterialGroup | null = null;

  private isDeleteDialog = false;

  // ページ読み込み時に実行
  private async mounted() {
    await this.fetchList();
  }

  /**
   * TODO: sort
   */

  private buttonStatus = true;

  private async upMenu(materialUuid: string) {
    const Direction: UpdateMaterialSort = {
      direction: true,
    };
    this.buttonStatus = false;
    try {
      await MaterialApi.instance.updateMaterialSortByUuId(materialUuid, Direction).then(() => {
        this.buttonStatus = true;
      });
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      this.buttonStatus = true;
    }
    await this.fetchList();
  }

  private async downMenu(materialUuid: string) {
    const Direction: UpdateMaterialSort = {
      direction: false,
    };
    this.buttonStatus = false;
    try {
      await MaterialApi.instance.updateMaterialSortByUuId(materialUuid, Direction).then(() => {
        this.buttonStatus = true;
      });
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      this.buttonStatus = true;
    }
    await this.fetchList();
  }

  // /sort

  // 削除アイコンclickで実行
  async onDeleteItem(uuid: string) {
    this.isDeleteDialog = true;
    this.targetItemUuid = uuid;
  }

  // 削除ダイアログの「ok」クリックで実行
  async deleteItem() {
    await this.deleteMaterial();
    this.closeDeleteDialog();
    this.listItems = [];
    await this.fetchList();
  }

  // materialの削除
  private async deleteMaterial() {
    try {
      if (this.targetItemUuid) {
        await MaterialApi.instance.deleteMaterialById(this.targetItemUuid);
      }
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // 削除ダイアログを閉じる
  private closeDeleteDialog() {
    this.isDeleteDialog = false;
  }

  // materialGroup情報の取得・material一覧の取得
  async fetchList() {
    const materialGroupRes = await MaterialGroupApi.instance.getMaterialGroupByUuid(this.materialGroupUuid);
    const materialGroup = materialGroupRes.data.data?.materialGroup;
    if (!materialGroup) {
      return;
    }
    this.materialGroup = materialGroup;
    if (!materialGroup.materials) {
      return;
    }
    this.listItems = materialGroup.materials.filter((material: { deleted: boolean }) => !material.deleted);

    this.listItems.sort((a: { sort: number }, b: { sort: number }) => {
      return a.sort - b.sort;
    });
  }
}
